import { preloadStore } from "./atoms/hey-api"
import type { CreateClientConfig } from "./heyapi/client.gen"

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  baseUrl: preloadStore.url,
  auth: preloadStore.authToken,
  credentials: "include", // Include cookies in requests
})
